import React, {FC, useState, useEffect} from "react"

import History from "@irati/utils/history"
import {getUserAccountCookie, removeUserAccountCookie, UserAccountForCookie} from "@irati/utils/cookies/userAccountCookie"
import {H1, Body} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import {RouterLink} from "@irati/ui/src/Link"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"

import LoginBlock from "../LoginBlock"
import OneTimePassword from "../LoginBackground"
import {StyledImage, StyledH5} from "./styled"

const ManageAccounts: FC = () => {
  const [userAccounts, setUserAccounts] = useState<UserAccountForCookie[]>([])
  const getAccounts = () => {
    const accounts = getUserAccountCookie()
    setUserAccounts(accounts)
  }
  useEffect(getAccounts, [])

  const removeAccount = (subdomain: string) => {
    removeUserAccountCookie(subdomain)
    getAccounts()
  }

  const handleBack = () => History.push("/welcome/login")

  const idNamespace = "manage_accounts"

  const helpLinks = [
    <FormattedMessage
      id="platform.defaultLogin.multipleTenants.help.otherDomain"
      values={{
        link: (
          <RouterLink to="/welcome/login/domain">
            <FormattedMessage id="platform.defaultLogin.multipleTenants.help.other.text" />
          </RouterLink>
        )
      }}
    />
  ]

  const hasUserAccounts = !!userAccounts && userAccounts.length > 0

  return (
    <OneTimePassword>
      <LoginBlock helpLinks={helpLinks} onBack={handleBack}>
        <H1 marginBottom={1} textAlign="center">
          <FormattedMessage id="platform.defaultLogin.manageAccounts.header" />
        </H1>
        {!hasUserAccounts && (
          <Body marginBottom={3} textAlign="center" maxWidth="100%">
            <FormattedMessage id="platform.defaultLogin.manageAccounts.noAccounts" />
          </Body>
        )}
        {hasUserAccounts && (
          <>
            <Body marginBottom={3} textAlign="center" maxWidth="100%">
              <FormattedMessage id="platform.defaultLogin.manageAccounts.body" />
            </Body>
            {userAccounts.map(({name, image, subdomain}, index) => {
              return (
                <Flex key={name} marginBottom={index < userAccounts.length - 1 ? 2 : 3} alignItems="center">
                  <StyledImage src={image} />
                  <StyledH5>{name}</StyledH5>
                  <Button destructive onClick={() => removeAccount(subdomain)}>
                    <FormattedMessage id="platform.defaultLogin.manageAccounts.remove" />
                  </Button>
                </Flex>
              )
            })}
          </>
        )}
      </LoginBlock>
    </OneTimePassword>
  )
}

export default ManageAccounts
